// get(resource, slug = "", params) ：用于获取数据；
// post(resource, params, config) ：用于提交数据（新建），表单提交和文件上传等
// patch(resource, params, config) ,put(resource, params, slug = "")：用于更新数据（修改）；
// delete(resource, params, config) ：用于删除数据；


import Vue from "vue";
//引入刚刚的配置好的axios拦截器
import axios from "@/service/interceptors.service";
import VueAxios from "vue-axios";

const ApiService = {
  //初始化方法用vue-axios组件
  init() {
    console.log('222')
    Vue.use(VueAxios, axios);
    //设置api的baseURL
    Vue.axios.defaults.baseURL = "http://xwzx.hohu.com.cn/api";
  },
   
  //创建不同的网络请求方法
  get(resource, params) {
    return Vue.axios.get(`${resource}`, { params }).catch(error => {
      throw error.response;
    });
  },

  post(resource, params, config) {
    return Vue.axios.post(`${resource}`, params, config).catch(error => {
      throw error.response;
    });
  },

  patch(resource, params, slug = "") {
    return Vue.axios.patch(`${resource}/${slug}`, params).catch(error => {
      throw error.response;
    });
  },

  put(resource, params, slug = "") {
    return Vue.axios.put(`${resource}/${slug}`, params).catch(error => {
      throw error.response;
    });
  },

  delete(resource, params, slug = "") {
    return Vue.axios
      .delete(`${resource}/${slug}`, { data: params })
      .catch(error => {
        throw error.response;
      });
  }
};

export default ApiService;
